import type { FC } from 'react';
import { List, ListItem } from '@george-labs.com/design-system';

interface Props {
    'data-cy': string;
    services: { nameI18N: string }[];
}

export const ProductServices: FC<Props> = ({ 'data-cy': dataCy, services }) => (
    <List variant={List.VARIANT.CHECKMARKS} data-cy={dataCy}>
        {services.map(({ nameI18N }) => (
            <ListItem className="pl-3" data-cy={`${dataCy}-service`} key={nameI18N}>
                {nameI18N}
            </ListItem>
        ))}
    </List>
);
